import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';

// Sentry is deliberately NOT wired here yet: this app renders a password field, and error reporting
// that has not been reviewed for what it captures from the DOM is a leak waiting to happen. See
// docs/ARCHITECTURE.md, decision D-4.
bootstrapApplication(App, appConfig).catch((error: unknown) => {
  // Bootstrap failed, so there is no Angular error handler and no UI. The console is all there is.
  console.error(error);
});
